import { Button, Form, Space } from 'antd'
import { NamePath } from 'antd/es/form/interface'
import { useTranslation } from 'react-i18next'

import { RefundDestinationsSelect } from '../RefundDestinationsSelect'

type Props = {
  loading?: boolean
  label?: React.ReactNode
  name?: NamePath
  disabledSelect?: boolean
  onChangeRefund?: () => void
  onRefund?: () => void
}

export const RefundMoneyButton = ({
  name = 'refund_destination',
  label,
  loading,
  disabledSelect,
  onChangeRefund,
  onRefund
}: Props) => {
  const { t } = useTranslation()

  return (
    <Space.Compact>
      <Form.Item name={name} label={label}>
        <RefundDestinationsSelect
          disabled={disabledSelect}
          onChange={onChangeRefund}
        />
      </Form.Item>
      <Button type="primary" loading={loading} onClick={onRefund}>
        {t('refund')}
      </Button>
    </Space.Compact>
  )
}
